export default "/static/build/jcb.png";